import React, { Component, useState, useEffect } from 'react'
import '../styles/LandOwnershipAndFarmingArea.css'
import '../styles/Widget.css'
import DropdownWidget from '../widgets/DropdownWidget'
import SwitchWidget from '../widgets/SwitchWidget'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import APIGenericRequest from '../api/APIGenericRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import AlertMessage from '../widgets/AlertMessage'
import DatePicker from '../widgets/DatePicker'

class LandOwnershipAndFarmingArea extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			classification: (props.classification == null)? "arb": props.classification,
			subClassProp: (props.subClass == null)? 0: props.subClass,
			subClass: (props.subClass == null)? 0: props.subClass,
			landList: {},
			successors: {},
			dateToday: props.dateToday,
			extName: [],
			mainlot:[],
			test: {},
			allLand: {},
			all:{},
			region: {},
			province: {},
			city: {},
			barangay: {}
		}
		this.selectedFarmLocationDetails = this.selectedFarmLocationDetails.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
		this.getFarmerInfo = this.getFarmerInfo.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
	}

	componentWillMount() {
		if(this.props.farmerID != null) {
			this.getFarmerInfo()
			if(this.props.view === "view-details") {
				return
			}
		}
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
		this.setState({
			region: {id: this.props.regionId, name: this.props.regionName},
			province: {id: this.props.provinceId, name: this.props.provinceName},
		})
	}

	getFarmerInfo() {
		const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.farmerID))
		farmer.then((response) => {
			let mainLot
			let otherLots = [], cultivated = 0, residential = 0
			for(const v of response.results.farmerLandOwnership) {
				if(mainLot == null && v.lot_type_id === 1) {
					mainLot = v
				}
				else {
					otherLots.push(v)
					residential += ((v.lot_type_id != 2)? v.land_area: 0)
					cultivated += v.cultivated_area
				}
			}
			if(otherLots.length < 1) {
				otherLots = null
			}
			if(response.results.farmerHomeAddress != null) {
				const region = APIGenericRequest.getRegionById(this.state.accessToken, response.results.farmerHomeAddress.region_id)
				region.then((rr) => {
					const province = APIGenericRequest.getProvinceById(this.state.accessToken, response.results.farmerHomeAddress.province_id)
					province.then((pr) => {
						const city = APIGenericRequest.getCityById(this.state.accessToken, response.results.farmerHomeAddress.city_id)
						city.then((cr) => {
							const barangay = APIGenericRequest.getBarangayById(this.state.accessToken, response.results.farmerHomeAddress.barangay_id)
							barangay.then((br) => {
								this.setState({
									region: {id: rr.results.region_id, name: rr.results.name},
									province: {id: pr.results.id, name: pr.results.name},
									city: {id: cr.results.id, name: cr.results.name},
									barangay: {id: br.results.id, name: br.results.name}
								})
							})
						})
					})
				})
				if(mainLot == null) {
					mainLot = {
						region_id: response.results.farmerHomeAddress.region_id,
						province_id: response.results.farmerHomeAddress.province_id
					}
				}
			}
			this.setState({
				mainLot: mainLot,
				otherLots: otherLots,
				subClass: response.results.farmerRegistration.category_id,
				arbSuccessor: response.results.ARBSuccessor,
				designate: response.results.ARBWithDesignate,
				leasehold: response.results.farmLeasehold,
				lease: response.results.farmLease,
				totalCultivated: cultivated,
				totalResidential: residential
			})
			if(this.props.view === "view-details") {
				this.setAllFieldsDisabled(true)
			}
			else {
				this.setAllFieldsDisabled(false)
			}
		})
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.land-ownership *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	selectedFarmLocationDetails(id, val) {
		this.setState({regionId: id})
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "land-ownership":
				if(this.state.test[compId] === undefined) {
					this.state.test[compId] = {
						region_id: this.state.region.id,
						province_id: this.state.province.id,
						lot_type_id: "1",

					}
				}
				if(this.props.view === "update") {
					this.state.test[compId]["id"] = this.state.mainLot.id 
				}
				this.state.test[compId][key] = value
				this.eventHandler("other-lots", null, "main-land", this.state.test)
				break
			case "other-lots":
				if(this.state.allLand[key] === undefined) {
					this.state.allLand[key] = {}
				}
				this.state.allLand[key] = value
				if(key === "add" || key === "delete") {
					this.state.allLand["farmerLandOwnership"] = value
					this.props.onValueChange("land-ownership", "farmerLandOwnership", key, value)
				}
				else {
					for(const [prop, val] of Object.entries(this.state.allLand)) {
						for(const [prop1, val1] of Object.entries(val)) {
							this.state.all[prop1] = val1
						}
					}
					this.props.onValueChange("land-ownership", "farmerLandOwnership", "farmerLandOwnership", this.state.all)
				}
				break
			case "designate":
				this.props.onValueChange("designate", "ARBWithDesignate", key, value)
				break
			case "successor":
				this.props.onValueChange("successor", "successor", key, value)
				break
			case "leaseholder":
				this.props.onValueChange("leaseholder", "farmLeasehold", key, value)
				break
			case "lessee":
				this.props.onValueChange("lessee", "farmLease", key, value)
				break
		}
		if(e === "other-lots") {
			let totalCultivated = 0
			let totalResidential = 0
			if(this.state.allLand.farmerLandOwnership == null) {
				return
			}
			const list = Object.values(this.state.allLand.farmerLandOwnership)
			for(const l of list) {
				if(!isNaN(l.cultivated_area)) {
					totalCultivated += parseInt(l.cultivated_area)
				}
				if(!isNaN(l.land_area)) {
					totalResidential += parseInt(l.land_area)
				}
			}
			this.setState({totalCultivated: totalCultivated, totalResidential: totalResidential})
		}
	}

	render() {
		let topRow
		let midRow
		topRow = <div id="lofa-top">
			<FarmLocationDetails data={this.state.mainLot}
				region={this.state.region}
				province={this.state.province}
				city={this.state.city}
				barangay={this.state.barangay}
				view={this.props.view}
				onDropdownSelected={this.selectedFarmLocationDetails}
				handler={this.eventHandler} />
			<LandTenure data={this.state.mainLot}
				view={this.props.view}
				handler={this.eventHandler}
				dateToday={this.state.dateToday} />
			<TotalArea data={this.state.mainLot}
				classification={this.state.classification}
				handler={this.eventHandler}
				view={this.props.view} />
		</div>
		const subClass = (this.state.subClassProp != 0)? this.state.subClassProp: this.state.subClass
		switch(parseInt(subClass)) {
			case 1: // land-awardee
				midRow = <MidLandAwardee data={this.state.arbSuccessor}
					view={this.props.view}
					handler={this.eventHandler}
					dateToday={this.state.dateToday}
					extName={this.state.extName} />
				break
			case 2:
			case 3: // leaseholder
				midRow = <MidLeaseholder data={this.state.leasehold}
					handler={this.eventHandler}
					dateToday={this.state.dateToday}
					extName={this.state.extName} />
				break
			case 4: // lessee
				midRow = <MidTenant data={this.state.lease}
					handler={this.eventHandler}
					extName={this.state.extName} />
				break;
			case 5: //
				midRow = <MidHousehold data={this.state.designate}
					view={this.props.view}
					handler={this.eventHandler}
					extName={this.state.extName} />
				break;
			case 6: //
				midRow = <MidHousehold data={this.state.designate}
					view={this.props.view}
					handler={this.eventHandler}
					extName={this.state.extName} />
				break;
		}
		let isOn = false
		if(this.state.otherLots != null) {
			document.getElementById('other-lots-area').style.display = 'block'
			isOn = true
		}
		let isDisabled = true
		if(this.state.region != null) {
			if(this.state.region.id != null) {
				isDisabled = false
			}
		}
		const view = <div className="land-ownership">
			{topRow}
			<div id="lofa-mid">{midRow}</div>
			<div id="lofa-bottom">
				<div id="other-lots-toggle">
					<SwitchWidget isOn={isOn} view={this.props.view} onToggle={(v) => {
						if(v) {
							document.getElementById('other-lots-area').style.display = 'block'
						}
						else {
							document.getElementById('other-lots-area').style.display = 'none'
							for(const l in this.state.landList) {
								if(l !== "main-land") {
									delete this.state.landList[l]
								}
							}
							if(this.state.otherLots != null) {
								this.eventHandler("other-lots", null, "delete", this.state.otherLots)
							}
						}
						this.setState({
							hasOtherLots: v,
							otherLots: null
						})
					}} isDisabled={isDisabled} />
					<span>Farmer has other lots</span>
				</div>
				<div id="other-lots-area">

					<OtherLots data={this.state.otherLots} view={this.props.view} regionID={this.state.region.id}
						handler={this.eventHandler} hasOL={this.state.hasOtherLots} view={this.props.view} dateToday={this.state.dateToday} />

					<div id="ola-total">
						<div id="total-lot-areas">
							<div>Total Area Cultivated</div>
							<div className="ta-cell">
								<input type="text" id="total-cultivated" value={this.state.totalCultivated} disabled={true} />
								<div>Hectares</div>
							</div>
						</div>
						<div id="total-lot-areas">
							<div>Total house/residential lot</div>
							<div className="ta-cell">
								<input type="text" id="total-residential" value={this.state.totalResidential} disabled={true} />
								<div>Hectares</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false, isOn: false})
				}} 
			/>}
		</div>
		return(view)
	}
}

class LandTenure extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			ownership: [{id: 1, name: "INDIVIDUAL"}, {id: 0, name: "GROUP"}],
			handler: props.handler,
			instrumentFor: 1,
			dateToday: props.dateToday,
			instrument: "-- SELECT --",
			isForIndividual: "-- SELECT --",
			owner: "-- SELECT --",
			main_lot: {},
		}
	}

	componentWillMount() {
		const instrument = APIFarmerRequest.getAllLOInstruments(this.state.accessToken)
		instrument.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.instrument_id, name: v.name})
			}
			this.setState({instruments: c})
		})
	}

	componentDidUpdate(prevProps) {
		if(this.props.data == prevProps.data) {
			return
		}
		if(this.props.data != null) {
			const instrument = APIFarmerRequest.getInstrumentById(this.state.accessToken, this.props.data.instrument_id)
			instrument.then((response) => {
				if(this.props.data.date_issued) {
					const d1 = new Date(this.props.data.date_issued)
					let m = (d1.getMonth()<10)? "0"+(d1.getMonth()+1): (d1.getMonth()+1)
					let d = (d1.getDate()<10)? "0"+d1.getDate(): d1.getDate()
					var dateIssued = d1.getFullYear() + "-" + m + "-" + d
				}
				let owner
				switch(this.props.data.is_instrument_for_individual) {
					case 1:
						owner = 'INDIVIDUAL'
						break
					case 0:
						owner = 'GROUP'
						break
					default:
						owner = '-- SELECT --'
				}
				this.setState({
					instrument: (response.results.name)? response.results.name: '-- SELECT --',
					owner: owner,
					dateIssued: dateIssued,
					serialNo: this.props.data.serial_no
				})
			})
		}
	}

	render() {
		return(<div id="lofa-land-tenure">
			<div>Land Tenure / Ownership Instrument</div>
			<DropdownWidget list={this.state.instruments} placeholder={this.state.instrument} cStyle={{"width": "100%"}}
				onItemSelected={(id, val) => {
					this.state.handler("land-ownership", "main-land", "instrument_id", id)
					this.state.handler("land-ownership", "main-land", "is_same_as_home_address", 0)
				}}
			/>
			<DropdownWidget list={this.state.ownership} placeholder={this.state.owner} cStyle={{"width": "100%"}}
				onItemSelected={(id, val) => {
					this.state.handler("land-ownership", "main-land", "is_instrument_for_individual", id)
				}}
			/>
			<div id="lt-cell">
				<DatePicker value={this.state.dateIssued} name="date-tenure" max={this.state.dateToday} onChange={(value) => {
					this.state.handler("land-ownership", "main-land", "date_issued", value)
				}} />
				<input type="text" id="lofa-serial-no" value={this.state.serialNo} onChange={(e) => {
					this.state.handler("land-ownership", "main-land", "serial_no", e.target.value)
					this.setState({serialNo: e.target.value})
				}} />
			</div>
		</div>)
	}
}

function TotalArea(props) {
	const [landArea, setLandArea] = useState()
	const [cultivatedArea, setCultivatedArea] = useState()
	let isSameAddress = false
	if(props.data != null) {
		isSameAddress = (props.data.is_same_as_home_address == 0)? false: true
	}
	useEffect(() => {
		if(props.data != null) {
			setLandArea(props.data.land_area)
			setCultivatedArea(props.data.cultivated_area)
		}
	}, [props.data])

	return(<div id="lofa-total-area">
		<div className="area-title">* Total Area Awarded / in the Title</div>
		<div className="ta-cell">
			<input type="text" id="ta-title" value={landArea} placeholder='0' onChange={(e) => {
				const checker = /^[\d,]+\.?\d{0,4}?$/
				const isValid = checker.test(e.target.value)
				if(isValid) {
					if(e.target.value > 5) {
						e.target.value = ''
						return
					}
					props.handler("land-ownership", "main-land", "land_area", e.target.value)
					setLandArea(e.target.value)
				}
				else {
					if(isNaN(parseInt(e.target.value))) {
						e.target.value = ""
						setLandArea('')
					}
					else {
						e.target.value = parseInt(e.target.value)
					}
				}
			}} />
			<div>Hectares</div>
		</div>
		<div>* Total Area Cultivated</div>
		<div className="ta-cell">
			<input type="text" id="ta-cultivated" value={cultivatedArea} placeholder='0' onChange={(e) => {
				const checker = /^[\d,]+\.?\d{0,4}?$/
				const isValid = checker.test(e.target.value)
				if(isValid) {
					if(e.target.value > 5) {
						e.target.value = ''
						return
					}
					props.handler("land-ownership", "main-land", "cultivated_area", e.target.value)
					setCultivatedArea(e.target.value)
				}
				else {
					if(isNaN(parseInt(e.target.value))) {
						e.target.value = ""
						setCultivatedArea('')
					}
					else {
						e.target.value = parseInt(e.target.value)
					}
				}
			}} />
			<div>Hectares</div>
		</div>
		<div id="yow" style={{'display': 'none', "color":"#B93832", 'padding-bottom': '10px'}}> - Should be a number. <br/>- Cultivated area should not be less than the area in the title. <br/>- Should not be a 0.</div>
			{props.classification === "arb" && <div className="ta-cell-last">
			<div>
				<SwitchWidget isOn={isSameAddress} view={props.view} onToggle={(v) => {
					let same_add = 1
					same_add = (v === true)? same_add:0
					props.handler("land-ownership", "main-land", "is_same_as_home_address", same_add)
				}} />
			</div>
			<div>House lot located in the area.</div>
		</div>}
	</div>)
}

class FarmLocationDetails extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			regionPlaceholder: (props.region.name != null)? props.region.name: "REGION",
			provincePlaceholder: (props.province.name != null)? props.province.name: "PROVINCE",
			cityPlaceholder: (props.city.name != null)? props.city.name: "CITY/MUNICIPALITY",
			brgyPlaceholder: (props.barangay.name != null)? props.barangay.name: "BARANGAY",
			onDropdownSelected: props.onDropdownSelected
		}
		this.getAllRegions = this.getAllRegions.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		this.getRegionById = this.getRegionById.bind(this)
		this.getProvinceById = this.getProvinceById.bind(this)
		this.getCityById = this.getCityById.bind(this)
		this.getBarangayById = this.getBarangayById.bind(this)
	}

	componentWillMount() {
		if(this.props.region.id != null) {
			this.setState({
				provincePlaceHolder: "PROVINCE",
				cities: [],
				cityPlaceholder: "CITY/MUNICIPALITY",
				brgyPlaceholder: "BARANGAY"
			})
		}
		this.getAllRegions()
	}

	componentDidUpdate(prevProps) {
		if(this.props.region.name != prevProps.region.name) {
			this.setState({regionPlaceHolder: this.props.region.name})
		}
		if(this.props.province.name != prevProps.province.name) {
			this.setState({provincePlaceHolder: this.props.province.name})
		}
		if(this.props.city.name != prevProps.city.name) {
			this.setState({cityPlaceHolder: this.props.city.name})
		}
		if(this.props.barangay.name != prevProps.barangay.name) {
			this.setState({barangayPlaceHolder: this.props.barangay.name})
		}
		if(this.props.data == prevProps.data) {
			return
		}
		if(this.props.data != null) {
			this.getRegionById()
		}
	}

	getRegionById() {
		const region = APIGenericRequest.getRegionById(this.state.accessToken, this.props.data.region_id)
		region.then((rc) => {
			if(this.props.province.name != "PROVINCE") {
				this.getProvinceById()
				this.getAllProvincesByRegionId(this.props.data.region_id, true)
				this.setState({
					regionPlaceholder: rc.results.name,
				})
			}
			else {
				this.setState({
					regionPlaceholder: rc.results.name,
					provincePlaceHolder: "PROVINCE",
					cities: [],
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
		})
	
	}

	getProvinceById() {
		if(this.props.province.id != null) {
			var provId = this.props.province.id
			var reset = true
		}
		else {
			provId = this.props.data.province_id
			reset = false
			this.getCityById()
		}
		const prov = APIGenericRequest.getProvinceById(this.state.accessToken, provId)
		prov.then((rc) => {
			this.getAllCitiesByProvinceId(provId, reset)
			if(this.props.province.id != null) {
				this.setState({
					provincePlaceHolder: this.props.province.name,
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
				return
			}
			const prov = (this.props.province.name != null)? this.props.province.name: rc.results.name
			this.setState({provincePlaceholder: prov})
		})
}

	getCityById() {
		if(this.props.city.id != null) {
			var cityId = this.props.city.id
			var reset = true
		}
		else {
			cityId = this.props.data.city_id
			reset = false
		}
		const city = APIGenericRequest.getCityById(this.state.accessToken, cityId)
		city.then((rc) => {
			if(rc.status === "FAILED") {
				this.setState({
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
				return
			}
			this.getBarangayById()
			this.getAllBarangaysByCityId(cityId, reset)
			const city = (this.props.city.name != null)? this.props.city.name: rc.results.name
			this.setState({cityPlaceholder: city})
		})
	}

	getBarangayById() {
		const brgy = APIGenericRequest.getBarangayById(this.state.accessToken, this.props.data.barangay_id)
		brgy.then((rc) => {
			this.setState({brgyPlaceholder: rc.results.name})
		})
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.region_id, name: v.name})
			}
			this.setState({
				regions: c,
				regionPlaceholder: "REGION",
				provincePlaceholder: "PROVINCE",
				cityPlaceholder: "CITY/MUNICIPALITY",
				brgyPlaceholder: "BARANGAY"
			})
		})
	}

	getAllProvincesByRegionId(id, reset) {
		const prov = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		prov.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			if(reset) {
				this.setState({
					provinces: c,
					provincePlaceholder: "PROVINCE",
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({provinces: c})
			}
		})
	}

	getAllCitiesByProvinceId(id, reset) {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			if(reset) {
				this.setState({
					cities: c,
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({cities: c})
			}
		})
	}

	getAllBarangaysByCityId(id, reset) {
		const city = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name})
			}
			if(reset) {
				this.setState({
					barangays: c,
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({barangays: c})
			}
		})
	}

	render() {
		const view = <div id="lofa-location">
			<div>* Farm Location Details</div>
				{/* <input type="text" value={this.state.regionPlaceholder} disabled={true} />
				<input type="text" value={this.state.provincePlaceholder} disabled={true} /> */}
				<DropdownWidget list={this.state.regions} placeholder={this.state.regionPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.props.handler("land-ownership", "main-land", "region_id", id)
					this.getAllProvincesByRegionId(id, true)
				}} />
				<DropdownWidget list={this.state.provinces} placeholder={this.state.provincePlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.props.handler("land-ownership", "main-land", "province_id", id)
					this.getAllCitiesByProvinceId(id, true)
				}} />
				<DropdownWidget list={this.state.cities} placeholder={this.state.cityPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.props.handler("land-ownership", "main-land", "city_id", id)
					this.getAllBarangaysByCityId(id, true)
				}} />
				<DropdownWidget list={this.state.barangays} placeholder={this.state.brgyPlaceholder}
					cStyle={{"width": "100%"}} onItemSelected={(id, val) => {	
					this.props.handler("land-ownership", "main-land", "barangay_id", id)
				}} />
			</div>
		return(view)
	}
}

class MidLandAwardee extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			memberCount: 0,
			itemObj: {},
			familyMembers: [],
			keyTracer: 0,
			relationToARB: props.relationToARBd,
			dateToday: props.dateToday,
			extName: props.extName,
			famMembers: {},
			addFamMembers: {},
			delFamMembers: {},
		}
		this.eventHandler = this.eventHandler.bind(this)
		if(props.data == null) {
			const k = "fm-" + this.state.keyTracer
			this.state.itemObj[k] = <FamilyMember
				view = {this.props.view}
				realationToARB={props.relationToARB}
				handler={this.eventHandler} key={k} id={k}
				dateToday={this.state.dateToday}
				extName={this.state.extName} />
			this.state.keyTracer++
			this.state.familyMembers.push(this.state.itemObj[k])

		}
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "set-data":
				this.state.famMembers[compId] = value;
				if(this.props.view === "update") {
					if(this.state.famMembers[compId]["id"] != undefined) {
						this.props.handler("successor", "successor", "successor", this.state.famMembers)
					}
				} else {
					this.props.handler("successor", "successor", "successor", this.state.famMembers)
				}
				break
			case "add":
				if(value != null && this.props.view === "update") {
					this.state.addFamMembers[compId] = value;
					this.props.handler("successor", "successor", "add", this.state.addFamMembers);
				}
				const added = []
				const k = "fm-" + this.state.keyTracer
				this.state.itemObj[k] = <FamilyMember
					view = {this.props.view}
					handler={this.eventHandler}
					key={k} id={k}
					dateToday={this.state.dateToday}
					extName={this.state.extName} />
				this.state.keyTracer++
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({familyMembers: added, memberCount: this.state.memberCount+1})
				break
			case "delete":
				if(value != null && this.props.view === "update") {
					this.state.delFamMembers[compId] = value;
					this.props.handler("successor", "successor", "delete", this.state.delFamMembers);
					delete this.state.addFamMembers[compId];
					this.props.handler("successor", "successor", "add", this.state.addFamMembers);
				}
				if(this.state.familyMembers.length === 1) {
					break
				}
				delete this.state.itemObj[compId]
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				this.props.handler("successor", compId, null, null)
				this.setState({familyMembers: deleted, memberCount: this.state.memberCount-1})
		}
	}

	componentDidMount() {
		if(this.props.data == null) {
			return
		}
		const members = []
		let count = 0
		for(const v of this.props.data) {
			const k = "fm-" + this.state.keyTracer
			this.state.itemObj[k] = <FamilyMember data={v}
				view = {this.props.view}
				handler={this.eventHandler}
				key={k} id={k}
				dateToday={this.state.dateToday}
				extName={this.state.extName} />
			this.state.keyTracer++
			count++
		}
		if(this.props.view === "update") {
			const k = "fm-" + this.state.keyTracer
			this.state.itemObj[k] = <FamilyMember
				view = {this.props.view}
				handler={this.eventHandler}
				key={k} id={k}
				dateToday={this.state.dateToday}
				extName={this.state.extName} />
			this.state.keyTracer++
		}
		Object.keys(this.state.itemObj).forEach((k => {
			members.push(this.state.itemObj[k])
		}))
		this.setState({familyMembers: members, memberCount: count})
	}

	render() {
		return(<div id="mid-land-awardee">
			<div id="mla-count">
				<div id="mla-number">{this.state.memberCount}</div>
				<div>Number of successor / heir of the awarded land </div>
			</div>
			<div id="mla-header">
				<table className="mla-table-header">
					<col style={{width: '60%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<tr>
						<th>Household/Family Member Name</th>
						<th>Relation of the regristrant to the ARB</th>
						<th>Birthday</th>
					</tr>
				</table>
				{this.state.familyMembers}
			</div>
		</div>)
	}
}

class FamilyMember extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			handler: props.handler,
			dateToday: props.dateToday,
			extName: props.extName,
			extn: "EXT",
			relation: "-- SELECT --",
			famMembers: {},
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const relations = APIFarmerRequest.getAllRelationshipsToARB(this.state.accessToken)
		relations.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.relationship_id, name: v.name})
			}
			this.setState({relationsToARB: c})
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.famMembers["id"] = this.props.data.id;
			const relation = APIFarmerRequest.getRelationshipToARBById(this.state.accessToken, this.props.data.relationship_id)
			relation.then((response) => {
				this.setState({relation: response.results.name})
			})

			const d1 = new Date(this.props.data.birth_date)
			let m = (d1.getMonth()<10)? "0"+(d1.getMonth()+1): (d1.getMonth()+1)
			let d = (d1.getDate()<10)? "0"+d1.getDate(): d1.getDate()
			var birthDate = d1.getFullYear() + "-" + m + "-" + d
			this.setState({
				addDeleteButton: (this.props.view === 'update')? <img src={deleteIcon} className="delete-icn" alt="DELETE" onClick={this.onDeleteItem}/>:<img src={deleteIconGray} className="delete-icn" alt="DELETE"/>,
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				extn: this.props.data.extension_name,
				birthDate: birthDate
			})
		}
		else {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
		}
	}

	onAddItemClick() {
		this.state.handler("add", this.state.itemId, null, this.state.famMembers)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		const fn = this.state.famMembers.first_name? this.state.famMembers.first_name: this.state.firstName
		const ln = this.state.famMembers.last_name? this.state.famMembers.last_name: this.state.lastName
		const name = `${fn} ${ln}`
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove family member ${name}?`
		})
	}

	render() {
		const view = <div className="family-member">
			<div className="img-btn">{this.state.addDeleteButton}</div>
			<table className="mla-table-data">
					<col style={{width: '60%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
				<tr>
					<td>
						<div className="hh-name">
							<input type="text" className="hh-fn" value={this.state.firstName} placeholder="FIRST NAME" cStyle={{"width": "30%"}} onChange={(e) => {
								this.state.famMembers["first_name"] = e.target.value;
								this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
								this.setState({firstName: e.target.value})
							}} />
							<input type="text" className="hh-mn" value={this.state.middleName} placeholder="MIDDLE NAME" cStyle={{"width": "30%"}} onChange={(e) => {
								this.state.famMembers["middle_name"] = e.target.value;
								this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
								this.setState({middleName: e.target.value})
							}} />
							<input type="text" className="hh-ln" value={this.state.lastName} placeholder="LAST NAME" cStyle={{"width": "30%"}} onChange={(e) => {
								this.state.famMembers["last_name"] = e.target.value;
								this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
								this.setState({lastName: e.target.value})
							}} />
							<DropdownWidget list={this.state.extName} placeholder={this.state.extn} cStyle={{"width": "10%", "margin-left": "5px"}}
								onItemSelected={(id, val) => {
									this.state.famMembers["extension_name"] = val;
									this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
									if(this.state.addDeleteButton.props.alt == "ADD") {
										this.onAddItemClick()
									}
							}} />
						</div>
					</td>
					<td><DropdownWidget list={this.state.relationsToARB} placeholder={this.state.relation}
						cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
							this.state.famMembers["relationship_id"] = id;
							this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} /></td>
					<td><DatePicker name="date-tenure" value={this.state.birthDate} max={this.state.dateToday} onChange={(value) => {
						this.state.famMembers["birth_date"] = value;
						this.state.handler("set-data", this.state.itemId, null, this.state.famMembers)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} /></td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.state.handler("delete", this.state.itemId, null, this.state.famMembers)
				}
			}} />}
		</div>
		return(view)
	}
}

class MidLeaseholder extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			dateToday: props.dateToday,
			extName: props.extName,
			firstName: "FIRST NAME",
			middleName: "MIDDLE NAME",
			lastName: "LAST NAME",
			extn: "EXT",
		}
	}

	componentDidMount() {
		if(this.props.data == null) {
			return
		}
		this.setState({
			isDesignate: 1,
			firstName: this.props.data.first_name,
			middleName: this.props.data.middle_name,
			lastName: this.props.data.last_name,
			extn: this.props.data.extension_name,
			contractNo: this.props.data.dar_contract_no,
			leaseYear: this.props.data.year_issued
		})
	}
	render() {
		const view = <div id="mid-leaseholder">
			<div id="ml-lessor">
				<div>Name of Lessor/Land Owner</div>
				<div id="name">
					<input type="text" className="lh-fn" value={this.state.firstName} onChange={(e) => {
						this.props.handler("leaseholder", null, "first_name", e.target.value)
						this.setState({firstName: e.target.value})
					}} />
					<input type="text" className="lh-mn" value={this.state.middleName} onChange={(e) => {
						this.props.handler("leaseholder", null, "middle_name", e.target.value)
						this.setState({middleName: e.target.value})
				}} />
					<input type="text" className="lh-ln" value={this.state.lastName} onChange={(e) => {
						this.props.handler("leaseholder", null, "last_name", e.target.value)
						this.setState({lastName: e.target.value})
					}} />
					<DropdownWidget list={this.state.extName} placeholder={this.state.extn} cStyle={{"margin-top": "-5px"}}
						onItemSelected={(id, val) => {
							this.props.handler("leaseholder", null, "extension_name", val)
						}} />
				</div>
			</div>
			<div id="ml-contact" cStyle={{"margin-left": "5px"}}>
				<div>Contract No.</div>
				<input type="text" className="lh-cn" value={this.state.contractNo} onChange={(e) => {
					this.props.handler("leaseholder", null, "dar_contract_no", e.target.value)
					this.setState({contractNo: e.target.value})
				}} />
			</div>
			<div>
				<div>Lease Year</div>
				<input type="text" className="lh-ly" value={this.state.leaseYear} max={this.state.dateToday} onChange={(e) => {
					this.props.handler("leaseholder", null, "year_issued", e.target.value.slice(0,4))
					this.setState({leaseYear: e.target.value.slice(0,4)})
				}} />
			</div>
		</div>
		return(view)
	}
}

class MidHousehold extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			extName: props.extName,
			disabled: true,
			extn: "EXT",
			relationship: "-- SELECT --",
			status: "-- SELECT --"
		}
	}

	componentWillMount() {
		if(this.props.view === "view-details") {
			return
		}
		const relations = APIFarmerRequest.getAllRelationshipsToARB(this.state.accessToken)
		relations.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.relationship_id, name: v.name})
			}
			this.setState({relationsToARB: c})
		})
		const status = APIFarmerRequest.getAllARBStatuses(this.state.accessToken)
		status.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.arb_status_id, name: v.name})
			}
			this.setState({arbStatus: c})
		})
		this.setState({ondropdown: <DropdownWidget list={this.state.extName} placeholder="EXT" id="mt-ext" disabled={true}
			onItemSelected={(id, val) => {
				this.props.handler("designate", null, "extension_name", val)
			}} />})
	}

	componentDidMount() {
		if(this.props.data != null) {
			const status = APIFarmerRequest.getARBStatusById(this.state.accessToken, this.props.data.arb_status_id)
			status.then((response) => {
				this.setState({status: response.results.name})
			})
			const relation = APIFarmerRequest.getRelationshipToARBById(this.state.accessToken, this.props.data.relationship_id)
			relation.then((response) => {
				this.setState({relationship: response.results.name})
			})
			this.setState({
				isDesignate: 1,
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				extn: this.props.data.extension_name
			})
		}
	}

	render() {
		const view = <div id="mid-household">
			<div id="mh-switch">
				<div><SwitchWidget view={this.props.view} isOn={this.state.isDesignate} onToggle={(v) => {
					if(v) {
						document.getElementById('mt-fn').disabled = false
						document.getElementById('mt-mn').disabled = false
						document.getElementById('mt-ln').disabled = false
						this.setState({disabled: false})
					}
					else {
						const fn = document.getElementById('mt-fn')
						const mn = document.getElementById('mt-mn')
						const ln = document.getElementById('mt-ln')
						fn.disabled = true
						mn.disabled = true
						ln.disabled = true
						fn.value = ""
						mn.value = ""
						ln.value = ""
						this.props.handler("designate", null, null, null)
						this.setState({disabled: true})
					}
				}} /></div>
				<span>Designated Representative of ARB</span>
			</div>
			<div id="mh-arb">
				<div>Name of ARB represented</div>
				<div id="name">
					<input type="text" id="mt-fn" value={this.state.firstName} placeholder='FIRST NAME' disabled="true" onChange={(e) => {
						this.props.handler("designate", null, "first_name", e.target.value)
						this.setState({firstName: e.target.value})
					}} />
					<input type="text" id="mt-mn" value={this.state.middleName} placeholder='MIDDLE NAME'  disabled="true" onChange={(e) => {
						this.props.handler("designate", null, "middle_name", e.target.value)
						this.setState({middleName: e.target.value})
					}} />
					<input type="text" id="mt-ln" value={this.state.lastName} placeholder='LAST NAME' disabled="true" onChange={(e) => {
						this.props.handler("designate", null, "last_name", e.target.value)
						this.setState({lastName: e.target.value})
					}} />
					<DropdownWidget list={this.state.extName} placeholder={this.state.extn} id="mt-ext"
						onItemSelected={(id, val) => {
							this.props.handler("designate", null, "extension_name", val)
						}} />
				</div>
			</div>
			<div id="mh-status">
				<div>Status of ARB</div>
				<DropdownWidget list={this.state.arbStatus} placeholder={this.state.status} cStyle={{"width": "100%"}}
					 onItemSelected={(id, val) => {
						this.props.handler("designate", null, "arb_status_id", id)
					}} />
			</div>
			<div id="mh-relation">
				<div>Relation of the regristrant to the ARB</div>
				<DropdownWidget list={this.state.relationsToARB} placeholder={this.state.relationship} cStyle={{"width": "100%"}}
					 onItemSelected={(id, val) => {
						this.props.handler("designate", null, "relationship_id", id)
					}} />
			</div>

		</div>
		return(view)
	}
}

class MidTenant extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			withContract: [
				{id: 0, name: "WITHOUT LEASE CONTRACT EXECUTED"},
				{id: 1, name: "WITH LEASE CONTRACT EXECUTED"}
			],
			extName: props.extName,
			contract: "-- SELECT --",
			extn: "EXT"
		}
	}

	componentDidMount() {
		if(this.props.data == null) {
			return
		}
		this.setState({
			firstName: this.props.data.first_name,
			middleName: this.props.data.middle_name,
			lastName: this.props.data.last_name,
			extn: this.props.data.extension_name,
			contract: (this.props.data.iw_with_contract)? "WITH LEASE CONTRACT EXECUTED": "WITHOUT LEASE CONTRACT EXECUTED",
			years: this.props.data.no_of_years
		})

	}

	render() {
		const view = <div id="mid-tenant">
			<div id="ml-lessor">
				<div>Name of Lessor/Land Owner</div>
				<div id="name">
					<input type="text" className="mt-fn" value={this.state.firstName} placeholder='FIRST NAME' onChange={(e) => {
						this.props.handler("lessee", null, "first_name", e.target.value)
						this.setState({firstName: e.target.value})
					}} />
					<input type="text" className="mt-mn" value={this.state.middleName} placeholder='MIDDLE NAME' onChange={(e) => {
						this.props.handler("lessee", null, "middle_name", e.target.value)
						this.setState({middleName: e.target.value})
					}} />
					<input type="text" className="mt-ln" value={this.state.lastName} placeholder='LAST NAME' onChange={(e) => {
						this.props.handler("lessee", null, "last_name", e.target.value)
						this.setState({lastName: e.target.value})
					}} />
					<span><DropdownWidget list={this.state.extName} placeholder={this.state.extn}
					cStyle={{"margin-top": "-5px"}}
						onItemSelected={(id, val) => {
							this.props.handler("lessee", null, "extension_name", val)
						}} />
					</span>
				</div>
			</div>
			<div id="mt-contract">
				<div>Lease Contract</div>
				<DropdownWidget list={this.state.withContract} placeholder={this.state.contract}
					cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
						this.props.handler("lessee", null, "is_with_contract", id)
					}} />
			</div>
			<div id="mt-term">
				<div>Term of Contract</div>
				<input type="text" className="mt-term" value={this.state.years} onChange={(e) => {
					this.props.handler("lessee", null, "no_of_years", e.target.value)
					this.setState({years: e.target.value})
				}} />
				<span>Years</span>
			</div>
		</div>
		return(view)
	}
}

class OtherLots extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			dateToday: props.dateToday,
			data: props.data,
			itemObj: {},
			lotItems: [],
			keyTracer: 0,
			regionID: props.regionID,
			lot: {},
			addlot: {},
			deletelot:{},
		}
		this.eventHandler = this.eventHandler.bind(this)
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "forward-data":
					this.state.lot[compId] = value
					if(this.props.view === "update") {
						this.props.handler("other-lots", null, "farmerLandOwnership", this.state.lot)
					}
					else {
						this.props.handler("other-lots", null, "farmerLandOwnership", this.state.lot)
					}
				break
			case "add":
				if(this.props.view === "update" && value != null) {
					this.state.addlot[compId] = value
					this.props.handler("other-lots", null, "add", this.state.addlot)
				}
				const added = []
				const k = "ol-" + this.state.keyTracer
				this.state.itemObj[k] = <LotItem regionID={this.props.regionID} handler={this.eventHandler} key={k} id={k} dateToday={this.state.dateToday} />
				this.state.keyTracer++
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({lotItems: added})
				break
			case "delete":
				if(value != null && this.props.view === "update") {
					this.state.deletelot[compId] = value
					this.props.handler("other-lots", null, "delete", this.state.deletelot)
					delete this.state.addlot[compId]
					this.props.handler("other-lots", null, "add", this.state.addlot)
				}
				if(this.state.lotItems.length === 1) {
					break
				}
				delete this.state.itemObj[compId]
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				this.setState({lotItems: deleted})
				this.props.handler("other-lots", null, "farmerLandOwnership", this.state.lot)
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.data != prevProps.data) {
			if(this.props.data == null) {
				return
			}
			const lots = []
			let regionID
			let compId = 0
			for(const v of this.props.data) {
				const k = "ol-" + this.state.keyTracer
				this.state.itemObj[k] = <LotItem data={v}
					regionID={this.props.regionID}
					handler={this.eventHandler}
					view={this.props.view}
					key={k} id={k}
					dateToday={this.state.dateToday} />
				this.state.keyTracer++
				regionID = v.region_id
				this.state.lot["ol-" + compId] = v
			}
			if(this.props.view === "update") {
				const k = "ol-" + this.state.keyTracer
				this.state.itemObj[k] = <LotItem
					regionID={regionID}
					handler={this.eventHandler}
					view={this.props.view}
					key={k} id={k}
					dateToday={this.state.dateToday} />
				this.state.keyTracer++
			}

			Object.keys(this.state.itemObj).forEach((k => {
				lots.push(this.state.itemObj[k])
			}))
			this.setState({lotItems: lots})
			return
		}
		if(this.props.hasOL != prevProps.hasOL) {
			const lots = []
			const itemObj = {}
			const k = "ol-" + this.state.keyTracer
			const li = <LotItem regionID={this.props.regionID} handler={this.eventHandler} key={k} id={k} dateToday={this.state.dateToday} />
			lots.push(li)
			itemObj[k] = li
			this.state.keyTracer++
			this.setState({regionID: this.props.regionID, lotItems: lots, itemObj: itemObj})
		}
	}

	render() {
		const view = <div id="other-lots">
			{this.state.lotItems}
		</div>
		return(view)
	}
}

class LotItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			data: props.data,
			handler: props.handler,
			provincePlaceholder: "PROVINCE",
			cityPlaceholder: "CITY/MUNICIPALITY",
			brgyPlaceholder: "BARANGAY",
			regionID: props.regionID,
			ownership: [{id: 1, name: "INDIVIDUAL"}, {id: 0, name: "GROUP"}],
			dateToday: props.dateToday,
			instrument: "-- SELECT --",
			owner:  "-- SELECT --",
			forDetailsView: true,
			other_lot:{},
			lotType: "TYPE OF LOT"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		if(props.regionID != null) {
			this.getAllProvincesByRegionId(props.regionID)
		}
	}

	componentWillMount() {
		const instrument = APIFarmerRequest.getAllLOInstruments(this.state.accessToken)
		instrument.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.instrument_id, name: v.name})
			}
			this.setState({instruments: c})
		})
		const lot = APIFarmerRequest.getAllTypeOfLots(this.state.accessToken)
		lot.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				if (v.lot_type_id != 1) {
					c.push({id: v.lot_type_id, name: v.name})
				}
			}
			this.setState({lotTypes: c})
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.other_lot["id"] = this.props.data.id
			if(this.props.view === "update") {
				this.setState({	addDelete: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />,})
			} else {
				this.setState({	addDelete: <img src={deleteIconGray} className="delete-icon" alt="DELETE"/>,})
			}
			if(this.props.view === "update") {
				this.getAllProvincesByRegionId(this.props.data.region_id)
				this.getAllCitiesByProvinceId(this.props.data.province_id)
				this.getAllBarangaysByCityId(this.props.data.city_id)
			}
		}
		else {
			this.state.other_lot["region_id"] = this.props.regionID
			this.state.other_lot["is_same_as_home_address"] = 0
			this.setState({addDelete: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} key="add"/>})
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.data != null) {
			if(this.state.forDetailsView) {
				this.state.forDetailsView = false
				const prov = APIFarmerRequest.getProvinceById(this.state.accessToken, this.props.data.province_id)
				prov.then((rc) => {
					this.setState({provincePlaceholder: rc.results.name})
				})
				const city = APIFarmerRequest.getCityById(this.state.accessToken, this.props.data.city_id)
				city.then((rc) => {
					this.setState({cityPlaceholder: rc.results.name})
				})
				const brgy = APIFarmerRequest.getBarangayById(this.state.accessToken, this.props.data.barangay_id)
				brgy.then((rc) => {
					this.setState({brgyPlaceholder: rc.results.name})
				})
				const lot = APIFarmerRequest.getLotTypeById(this.state.accessToken, this.props.data.lot_type_id)
				lot.then((rc) => {
					this.setState({lotType: rc.results.name})
				})
				const instrument = APIFarmerRequest.getInstrumentById(this.state.accessToken, this.props.data.instrument_id)
				instrument.then((response) => {
					const d1 = new Date(this.props.data.date_issued)
					let m = (d1.getMonth()<9)? "0"+(d1.getMonth()+1): (d1.getMonth()+1)
					let d = (d1.getDate()<10)? "0"+d1.getDate(): d1.getDate()
					const dateIssued = d1.getFullYear() + "-" + m + "-" + d
					this.setState({
						instrument: response.results.name,
						owner: (this.props.data.is_instrument_for_individual === 1)? "INDIVIDUAL": "GROUP",
						dateIssued: dateIssued,
						serialNo: this.props.data.serial_no,
						landArea: this.props.data.land_area,
						cultivatedArea: this.props.data.cultivated_area,
						disabled: true
					})
					if(this.props.view === "view-details") {
						this.setAllFieldsDisabled(true)
					}
					else {
						this.setAllFieldsDisabled(false)
					}

				})
				return
			}
		}
		if(prevProps.regionID != this.props.regionID) {
			this.getAllProvincesByRegionId(this.props.regionID, true)
		}
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.lot-item *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.other_lot)
		this.setState({addDelete: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove lot with serial number ${this.state.serialNo}?`
		})
	}

	getAllProvincesByRegionId(id, reset) {
		const province = APIFarmerRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			if(reset) {
				this.setState({
					provinces: c,
					provincePlaceholder: "PROVINCE",
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({provinces: c})
			}
		})
	}

	getAllCitiesByProvinceId(id, reset) {
		const city = APIFarmerRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			if(reset) {
				this.setState({
					cities: c,
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({cities: c})
			}
		})
	}

	getAllBarangaysByCityId(id, reset) {
		const city = APIFarmerRequest.getAllBarangaysByCityId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name})
			}
			if(reset) {
				this.setState({
					barangays: c,
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({barangays: c})
			}
		})
	}

	render() {
		let landArea
		const view = <div className="lot-item">
			<div className="lot-item-img">{this.state.addDelete}</div>
			<div className="lot-item-location">
				<DropdownWidget list={this.state.provinces} placeholder={this.state.provincePlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					if(this.state.addDelete.props.alt == "ADD") {
						this.onAddItemClick()
					}
					this.state.other_lot["province_id"] = id
					this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
					const province = APIFarmerRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
					province.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.city_id, name: v.name})
						}
						this.setState({cities: c, cityPlaceholder: "CITY/MUNICIPALITY"})
					})
				}} />
				<DropdownWidget list={this.state.cities} placeholder={this.state.cityPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					if(this.state.addDelete.props.alt == "ADD") {
						this.onAddItemClick()
					}
					this.state.other_lot["city_id"] = id
					this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
					const province = APIFarmerRequest.getAllBarangaysByCityId(this.state.accessToken, id)
					province.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.barangay_id, name: v.name})
						}
						this.setState({barangays: c, brgyPlaceholder: "BARANGAY"})
					})
				}} />
				<DropdownWidget list={this.state.barangays} placeholder={this.state.brgyPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					if(this.state.addDelete.props.alt == "ADD") {
						this.onAddItemClick()
					}
					this.state.other_lot["barangay_id"] = id
					this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
				}} />
			</div>
			<div className="lot-item-ownership">
				<div>Ownership Instrument</div>
				<DropdownWidget list={this.state.instruments} placeholder={this.state.instrument} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					if(this.state.addDelete.props.alt == "ADD") {
						this.onAddItemClick()
					}
					this.state.other_lot[ "instrument_id"] = id
					this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
				}} />
				<DropdownWidget list={this.state.ownership} placeholder={this.state.owner} cStyle={{"width": "100%"}}
					onItemSelected={(id, val) => {
						if(this.state.addDelete.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.state.other_lot["is_instrument_for_individual"] = id
						this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
				}} />
				<div className="lio-cell">
					<input type="text" className="lio-serial-no" value={this.state.serialNo} placeholder="SERIAL NO." onChange={(e) => {
						if(this.state.addDelete.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.state.other_lot["serial_no"] = e.target.value
						this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
						this.setState({serialNo: e.target.value})
					}} />
					<DatePicker value={this.state.dateIssued} name="date-tenure" max={this.state.dateToday} onChange={(value) => {
						if(this.state.addDelete.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.state.other_lot["date_issued"] = value
						this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
					}} />
				</div>
			</div>
			<div className="lot-item-hectares">
				<DropdownWidget list={this.state.lotTypes} placeholder={this.state.lotType} cStyle={{"width": "100%"}}
					onItemSelected={(id, val) => {
						if(this.state.addDelete.props.alt == "ADD") {
							this.onAddItemClick()
						}
					this.state.other_lot["lot_type_id"] = id
					this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
				}} />
				<div className="lih-cell">
					<input type="text" className="lih-total" value={this.state.landArea} placeholder="TOTAL AREA" onChange={(e) => {
						const checker = /^[0-9.]+$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.state.other_lot["land_area"] = e.target.value
							this.setState({landArea: e.target.value})
							if(this.state.addDelete.props.alt == "ADD") {
								this.onAddItemClick()
							}
							else {
								this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
							}
						}
						else {
							this.state.other_lot["land_area"] = 0
							this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({landArea: ""})
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} />
					<div>Hectares</div>
				</div>
				<div className="lih-cell">
					<input type="text" className="lih-cultivated" value={this.state.cultivatedArea} placeholder="CULTIVATED AREA" onChange={(e) => {
						const checker = /^[0-9.]+$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.state.other_lot["cultivated_area"] = e.target.value
							this.setState({cultivatedArea: e.target.value})
							if(this.state.addDelete.props.alt == "ADD") {
								this.onAddItemClick()
							}
							else {
								this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
							}
						}
						else {
							this.state.other_lot["cultivated_area"] = 0
							this.props.handler("forward-data", this.state.itemId, null, this.state.other_lot)
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({cultivatedArea: ""})
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} />
					<div>Hectares</div>
				</div>
			</div>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("forward-data", this.state.itemId, "cultivated_area", 0)
					this.props.handler("forward-data", this.state.itemId, "land_area", 0)
					this.props.handler("delete", this.state.itemId, null, this.state.other_lot)
				}
			}} />}
		</div>
		return(view)
	}
}

export default LandOwnershipAndFarmingArea
